import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import { useUserInfo } from "../../../../context/user";
import { useUsersContext } from "../../../../context/usersContext";

const CustomiseYourAIExperience = ({ onTypeClick }) => {
  const { products } = useUsersContext();
  const userInfo = useUserInfo()[0];
  const userActiveLocation = useUserInfo()[4];

  const planId = userActiveLocation?.plan_id || userInfo?.plan_id;
  const activePlan = products?.find(item =>
    item?._id?.toString() === planId?.toString() ||
    item?.monthly_id === planId ||
    item?.yearly_id === planId
  );
  const isDeveloperPlan = activePlan?.developer_plan === true || userInfo?.developer_plan === true || userInfo?.developer_plan === "true";

  const userTypes = [
    {
      title: "Business",
      description: "Build AI Agents for your business",
    },
    {
      title: "Developer",
      description: "Build and deploy AI Agents",
    },
    {
      title: "Agency",
      description: "Build AI Agents for your clients",
    },
    {
      title: "Individual",
      description: "Build AI Agents to help you be awesome",
    },
  ];

  const filteredUserTypes = isDeveloperPlan ? userTypes : userTypes.filter(item => item.title !== "Developer");

  return (
    <div>
      <div>
        <div
          className="container-main !w-[430px]"
          style={{ background: "hsl(var(--background))" }}
        >
          <div className="container" style={{ background: "hsl(var(--background))" }}>
            <div className="">
              <div className="text-center pb-5">
                <h1 className="text-[30px] font-medium text-foreground">
                  Customise Your AI Experience
                </h1>
                <p className="mt-4 text-muted-foreground">
                  Tell us about your business so we can tailor Your AI solutions
                </p>
              </div>

              {filteredUserTypes.map((item, index) => {
                const isDisabled = isDeveloperPlan && item.title !== "Developer";
                return (
                  <div
                    key={index}
                    className={`group ${isDisabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}
                    onClick={() => !isDisabled && onTypeClick(item.title)}
                  >
                    <div className={`w-[420px] h-[108px] mt-5 border !border-border bg-card ${!isDisabled && "group-hover:bg-muted group-hover:!border-foreground/40"} pl-[35px] pr-7 rounded-md flex items-center justify-between`}>
                      <div className="flex flex-col items-start gap-3">
                        <b className="text-foreground">{item.title}</b>
                        <p className="text-muted-foreground">{item.description}</p>
                      </div>
                      <div className={`hidden ${!isDisabled && "group-hover:flex"}`}>
                        <ArrowForwardOutlinedIcon className="text-[20px] text-foreground" />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomiseYourAIExperience;
